

tagViewController = ($state, program, tag) ->
    'ngInject'
    @program = program
    @tag = tag
    @onDelete = -> $state.go('^.index')
    return


loadTag = ($stateParams, TagService, program) ->
    'ngInject'
    return TagService.get($stateParams.tagId)


makeState = (resolves) ->
    url: '/{tagId:int}'
    templateUrl: 'tags/view'
    resolve: resolves
    controller: tagViewController
    controllerAs: 'tagView'


states = ($stateProvider) ->
    'ngInject'

    $stateProvider.state 'tag.view', makeState
        program: -> null
        tag: loadTag

    $stateProvider.state 'program.tag.view', makeState
        tag: loadTag

module.config states